// components
import { SearchBar } from './SearchBar';
import { TableBackoffice } from '@commons/components';
// utils && hooks
import { useTableHooks } from './hooks';
// styles
import styles from './Table.module.css';

const Table = () => {
    const {
        isLoading,
        searchValue,
        columns,
        data,
        setSearchValue,
        setClientIdFilter,
        pagination,
        resetClientFilter,
        sort,
        ordering,
        handleSortChange,
        handleFetchWithClient,
        handleChangePage,
        handleChangeLimit,
    } = useTableHooks();

    return (
        <div className={styles['wrapper']}>
            <SearchBar
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                clearSearch={() => setSearchValue('')}
                setClientIdFilter={setClientIdFilter}
                handleFetch={handleFetchWithClient}
                resetClientFilter={resetClientFilter}
            />
            <div className={styles['wrapper-table']}>
                <TableBackoffice
                    data={data}
                    columns={columns}
                    tableHeigth={365}
                    loading={isLoading}
                    pagination={{
                        total: pagination?.total || 0,
                        activePage: pagination?.current_page,
                        limit: pagination?.per_page,
                        isLoading: isLoading,
                        onChangePage: (newPage) => handleChangePage(newPage),
                        onChangeLimit: (newLimit) => handleChangeLimit(newLimit),
                        pages: pagination?.total_pages,
                    }}
                    sortTable={{
                        onSortColumn: handleSortChange,
                        sortType: ordering,
                        sortColumn: sort,
                    }}
                />
            </div>
        </div>
    );
};

export default Table;
